import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import { deprecate } from 'react-is-deprecated';
import Glyphicon from '../Glyphicon/index.js';
import Button from '../Button/index.js';
import Link from '../Link/index.js';
import PartnerLink from '../PartnerLink/index.js';

/**
 * LinkIcon is used for displaying a hyperlink with an associated Glyphicon (`offsite` by default).
 */
function LinkIcon(_ref) {
  let {
    componentClass,
    children,
    label,
    // Deprecated
    placement = 'after',
    glyph = 'offsite',
    glyphClassName,
    undecorated = false,
    ...rest
  } = _ref;
  // Generate an initial content array from component's children
  const content = React.Children.toArray(children);

  // If label is supplied we need to up push it to existing content
  if (label) {
    content.push(/*#__PURE__*/_jsx(React.Fragment, {}, "linkIcon-label", label));
  }
  const hasHref = !!rest?.href;
  const bsStyle = undecorated ? 'text' : 'text-decorated';
  let Component = Button;
  if (rest.partner) {
    Component = PartnerLink;
  } else if (hasHref) {
    Component = Link;
    delete rest.bsStyle;
  } else {
    delete rest.target;
    delete rest.external;
  }
  const glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: glyph,
    className: glyphClassName,
    title: glyph === 'offsite' ? '(external)' : undefined
  }, glyph + placement);
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    "data-cmp": rest.partner ? undefined : 'linkIcon'
  }, rest, !hasHref ? {
    bsStyle
  } : {
    undecorated
  }), placement !== 'after' && /*#__PURE__*/React.createElement(React.Fragment, null, glyphicon, ' '), content, placement === 'after' && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', glyphicon));
}
export default LinkIcon;